import _ from 'lodash';
import i18next from 'i18next';
import moment from 'moment';

const CryptoJS = require('crypto-js');

export default {
    // 页面跳转到登录页面
    ToLoginPage(){
        let url = window.location.href.replace(window.location.hash, '');
        url = url.replace('app.html', 'login.html');
        window.open(url, '_self');
    },
    // 页面登录成功跳转
    ToAppPage(){
        let url = window.location.href.replace(window.location.hash, '');
        url = url.replace('login.html', 'app.html');
        window.open(url, '_self');
    },
    // 加密
    encryptByDESModeEBC(message) {
        var keyHex = CryptoJS.enc.Utf8.parse('IuFWKUut');
        var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    },
    // 解密
    decryptByDESModeEBC(message) {
        var keyHex = CryptoJS.enc.Utf8.parse('IuFWKUut');
        var decrypted = CryptoJS.DES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(message) }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    },
    // baidu地图获取经纬度
    getCurrentPosition() {
        return new Promise(function(resolve, reject) {
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(
                function(r) {
                    //关于状态码
                    //BMAP_STATUS_SUCCESS    检索成功。对应数值“0”。
                    //BMAP_STATUS_CITY_LIST    城市列表。对应数值“1”。
                    //BMAP_STATUS_UNKNOWN_LOCATION    位置结果未知。对应数值“2”。
                    //BMAP_STATUS_UNKNOWN_ROUTE    导航结果未知。对应数值“3”。
                    //BMAP_STATUS_INVALID_KEY    非法密钥。对应数值“4”。
                    //BMAP_STATUS_INVALID_REQUEST    非法请求。对应数值“5”。
                    //BMAP_STATUS_PERMISSION_DENIED    没有权限。对应数值“6”。(自 1.1 新增)
                    //BMAP_STATUS_SERVICE_UNAVAILABLE    服务不可用。对应数值“7”。(自 1.1 新增)
                    //BMAP_STATUS_TIMEOUT    超时。对应数值“8”。(自 1.1 新增)
                    if (this.getStatus() === BMAP_STATUS_SUCCESS) {
                        //精度为undefined 代表用户拒绝授权地理位置
                        // if (r.accuracy === null) {
                        //     reject({
                        //         type: '1', //授权失败
                        //         errorMessage: '请授权获取地理位置',
                        //     });
                        // }
                        let myGeo = new BMap.Geocoder();
                        myGeo.getLocation(new BMap.Point(r.longitude, r.latitude), result => {
                            console.log('hhh', result);
                            if (result) {
                                resolve({
                                    longitude: r.longitude,
                                    latitude: r.latitude,
                                    address: result.address,
                                });
                            } else {
                                reject({
                                    type: '2', //详细地址解析失败
                                    errorMessage: '详细地址解析失败',
                                });
                            }
                        });
                    } else {
                        reject({
                            type: '0', //百度地图api调用出错
                            errorMessage: '百度地图api调用出错',
                        });
                    }
                },
                function(err) {
                    //没有网络的返回值
                    if (err.errorCode === 3) {
                        reject({
                            type: '3', //超时，没有网络
                            errorMessage: '超时，没有网络',
                        });
                    } else {
                        reject({
                            type: '4', //未知的错误
                            errorMessage: 'unknown error',
                        });
                    }
                }
            );
        });
    },
};
